import { Flex, Stack } from '@chakra-ui/react';
import Card from '@molecules/Card';
import Text from '@molecules/Text';
import Divider from '@molecules/Divider';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useStore } from '@data/other/withStore';
import useFormat from '@business/utils/hooks/useFormat';

const Charges = () => {
  const {
    property: { reservation },
  } = useStore();
  const { t } = useTranslation();
  const { currency } = useFormat();

  return (
    <Card width="340px" padding={'16px'}>
      {!reservation.model ? (
        <></>
      ) : (
        <Stack>
          <Text type="h3" weight="500">
            {t('charges')}
          </Text>
          <Divider my="16px" />
          <Flex justifyContent="space-between">
            <Text>{t('subtotal')}</Text>
            <Text>{currency(reservation.model.charges_subtotal)}</Text>
          </Flex>
          <Flex justifyContent="space-between">
            <Text>{t('upgrades')}</Text>
            <Text>{currency(reservation.model.charges_upgrades)}</Text>
          </Flex>
          <Flex justifyContent="space-between">
            <Flex>
              <Text>{t('taxes-and-fees')}</Text>
              {/*
                    <Tooltip
                        id="tooltip"
                        Component={TaxesAndFees}
                        vat={5}
                        city_tax={5}>
                        <BEIcon name="info-circle" weight="regular" size="md" />
                    </Tooltip>
                    */}
            </Flex>
            <Text>{currency(reservation.model.charges_tax)}</Text>
          </Flex>
          <Divider my="16px" />
          <Flex justifyContent="space-between">
            <Text weight="600">{t('total')}</Text>
            <Text weight="600">
              {currency(reservation.model.charges_total)}
            </Text>
          </Flex>
          <Flex justifyContent="space-between">
            <Text weight="600">{t('amount-paid')}</Text>
            <Text weight="600">
              {currency(reservation.model.charges_paid_value)}
            </Text>
          </Flex>
          <Divider my="16px" />
          <Flex justifyContent="space-between">
            <Text type="h3" weight="600">
              {t('balance-due')}
            </Text>
            <Text type="h3" weight="600">
              {currency(reservation.model.charges_balance_due)}
            </Text>
          </Flex>
        </Stack>
      )}
    </Card>
  );
};

export default observer(Charges);
